export default __webpack_public_path__ + "static/media/Wallet.fba6cc87.svg";